import { useState, useEffect, useRef } from 'react';
import Bredcrum from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import { Tablescom } from '../../components/tablescomp';
import { Toast } from 'primereact/toast';

import { userservices } from '../../services/userServices';
import { productservices } from '../../services/productServices';
import { Titlebar, Searchbox, Label } from '../../components/fieldsComp';
import { useSelector } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import {HandleClose} from '../../helpers/formclose';
const Productadd = () => {

    const unitreducer = useSelector((state) => state.unitreducer);
    const [users, setUsers] = useState([]);
    const [units, setUnits] = useState([]);
    const [results, setResults] = useState([]);
    const [userloaded, setUserloaded] = useState(true);
    const [loading, setLoading] = useState(false);
    const [categorydata, setCatergorydata] = useState([]);
    const toast = useRef(null);
    const [selectcategory, setSelectCategory] = useState('');

    const [rows, setRows] = useState([{ id: Date.now(), quantity: 0 }]);

    const handleAddRow = () => {
        setRows([...rows, { id: Date.now(), quantity: 0 }]);
    };

    const handleRemoveRow = (index) => {
        const newRows = [...rows];
        newRows.splice(index, 1);
        setRows(newRows);
    };


    useEffect(() => {
        getcomponents();
        getCategoryData();
        getunits();
    }, []);

    const [formData, setFormData] = useState({
        product_name: '',
        sku_code: '',
        stock_on_hand: '',
        stock_needed: '',
        discrepancy_alert: '', // boolean: can be true/false or 'true'/'false'
        restock_alert_threshold: '',
        stock_location: '',
        stock_type: '', // 'finished' or 'component'
    });


    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSave = (values) => {
        setLoading(true);
        productservices.createproduct(values).then((response) => {
            if (response.status == 200) {
                setLoading(false);
                //  console.log€0
                toast.current.show({ severity: 'success', summary: 'Product', detail: 'Product added successfully' });
            } else {
                 setLoading(false);
                toast.current.show({ severity: 'error', summary: 'Product', detail: `${response.data.data}` });
            }
        }).catch((error) => {
             setLoading(false);
            toast.current.show({ severity: 'error', summary: 'Product', detail: 'Error' });
        });
    };

    const handleClose = () => {
        // Reset form or close modal logic
        console.log('Form Closed');
    };

    const getcomponents = () => {
        setUserloaded(false);
        productservices.getcomponents().then((response) => {
            if (response.status == 200) {
                //   console.log(response.data.data);
                setResults(response.data.data);
                setUserloaded(true);
            } else {
                setUsers([]);
                setUserloaded(true);
            }
        }).catch((error) => {
            setResults([]);
            setUserloaded(true);
        });
    }

    const getCategoryData = () =>{
        productservices.getcategory().then((response) => {
            if(response.status == 200){
                setCatergorydata(response.data.data);
            }
        }).catch((error) => {
            console.log("error : ", error);
        });
    }

    const CategoryOption = () => {
        return ( <>
         
            {categorydata.map((ele) => {
                return (
                    <>
                        <option key={ele.id} value={ele.id}>{ele.category_name}</option>
                    </>
                )
            })}
        </>
        )
    }

    const getunits = () => {
        let temparr = [];
        unitreducer.then((response) => {
            setUnits(response);
        }).catch((error) => {
        });
    }

    const displayunits = () => {
        let temparr = [];
        units.forEach((value, index) => {
            temparr.push(<option value={value.short_code}>{value.name}</option>)
        });
        return temparr;
    }

    const displayData = () => {
        let temparr = [];
        results.forEach((value, index) => {
            temparr.push(<option value={value.id}><span>Component : {value.component}</span> Sku : {value.componentSkuCode}</option>)
        })
        return temparr;
    }

    return (
        <>
            <Toast ref={toast} />
            <Bredcrum title={'Product / Add Product'} divider={false} />
            <div class="row">
                {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}


                {/* <Titlebar text={'Add Product'} /> */}
                <div className="col-md-12 mt-3">
                    <div className='card ps-3 pe-3'>
                        <div className='card-body card-body-style'>

                            <div className='row'>
                                <div className="container mt-4">
                                    <Formik
                                        initialValues={{
                                            product_name: '',
                                            sku_code: 'SKU-008',
                                            email: '',
                                            product_id: ''
                                        }}
                                        onSubmit={async (values) => {
                                            console.log("values data");
                                            console.log(values);
                                            handleSave(values);
                                            // await new Promise((r) => setTimeout(r, 500));
                                            // alert(JSON.stringify(values, null, 2));
                                        }}
                                    >
                                        <Form>
                                            <div className="row">
                                                <div className="col-md-6 form-group">
                                                    <Label name="Product Name" />
                                                    <Field type="text" name="product_name" className="form-control"
                                                        placeholder="Enter Product Name" required />
                                                </div>

                                                <div className="col-md-6 form-group">
                                                    <Label name="Master SKU Code" />
                                                    <Field type="text" name="sku_code" className="form-control"
                                                        placeholder="Enter Master SKU Code" required />
                                                </div>

                                                <div className="col-md-6 form-group">
                                                    <Label name="Stock Type" />
                                                    <Field as="select" name="stock_type" className="form-control"
                                                        placeholder="Stock Type" required >
                                                         <option value="">Select Stock type</option>  
                                                         <option value="finished">Finished</option> 
                                                         <option value="unfinished">UnFinished</option>   
                                                    </Field>
                                                </div>
                                                <div className="col-md-6 form-group">
                                                    <Label name="Product Img" />
                                                    <Field type="file" name="file" className="form-control"
                                                    accept="image/*"
                                                        placeholder="Product Image"/>
                                                </div>
                                                 <div className="col-md-6 form-group">
                                                    <Label name="Description" />
                                                    <Field as="textarea" name="notes" className="form-control"
                                                        placeholder="Enter Description" required />
                                                </div>
                                                <div className="col-md-6 form-group">
                                                    <Label name="Product Category" />
                                                    <Field as="select" name="category_id" className="form-control"
                                                        placeholder="Stock Type" >
                                                            <option  value=''>Select category</option>
                                                             {categorydata.map((ele) => {
                                                                    return (
                                                                        <>
                                                                            <option key={ele.id} value={ele.id}>{ele.category_name}</option>
                                                                        </>
                                                                    )
                                                                })}
                                                    </Field>
                                                </div>
                                            </div>

                                            <br></br>
                                            
                                            <div className="row">
                                                <div className='col-md-6'>
                                                    <button
                                                        type="submit"
                                                        className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                                                         disabled={loading} >
                                                        {loading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2" role="status" />
                                                            Loading...
                                                        </>
                                                    ) : (
                                                        "Save"
                                                    )}
                                                    </button>
                                                </div>

                                                 {<HandleClose/>}
                                            </div>
                                        </Form>

                                    </Formik>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Productadd;